var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C13.7267 20 16.8583 17.4517 17.7473 14.0026M10 20C6.27327 20 3.14171 17.4517 2.25271 14.0026M10 20C12.2091 20 14 16.4183 14 12C14 7.58172 12.2091 4 10 4M10 20C7.79086 20 6 16.4183 6 12C6 7.58172 7.79086 4 10 4M10 4C12.9913 4 15.5991 5.64172 16.9716 8.07329M10 4C7.00872 4 4.40088 5.64172 3.02838 8.07329M16.9716 8.07329C15.102 9.68924 12.6651 10.6667 10 10.6667C7.33486 10.6667 4.89802 9.68924 3.02838 8.07329M16.9716 8.07329C17.6264 9.23327 18 10.573 18 12C18 12.6915 17.9123 13.3626 17.7473 14.0026M17.7473 14.0026C15.4519 15.2753 12.8106 16 10 16C7.18943 16 4.54811 15.2753 2.25271 14.0026M2.25271 14.0026C2.08775 13.3626 2 12.6915 2 12C2 10.573 2.37362 9.23327 3.02838 8.07329",
    stroke: "#290064",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.419a4899861d49997bde7bbd8d82ec49.svg";
export { ForwardRef as ReactComponent };